import React, { useRef } from "react";
import { Box, IconButton as MuiButton, Tooltip } from "@mui/material";

interface Props {
  onClick: () => void;
  icon: React.ReactElement;
  label: string;
  disabled?: boolean;
  size?: "small" | "medium" | "large"
}

const IconButton: React.FC<Props> = (props) => {
  const { onClick, icon, label, disabled, size } = props;
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  return (
    <Box component={"span"}>
      <Tooltip title={label}>
        <MuiButton
          color="inherit"
          ref={anchorRef}
          onClick={onClick}
          disabled={disabled}
          type="button"
          size={size}
        >
          {icon}
        </MuiButton>
      </Tooltip>
    </Box>
  );
};

export default IconButton;
